import fs from 'fs'
import { Hero, Layout } from '@components/common'
import { Container } from '@components/ui'
import { GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import { remark } from 'remark'
import html from 'remark-html'
import { Breadcrumb } from '@types'
import gfm from 'remark-gfm'

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  const content = await remark()
    .use(html)
    .use(gfm)
    .process(fs.readFileSync(`content/${locale}/size-chart.md`))

  return {
    props: {
      ...(await serverSideTranslations(locale || 'en-US', ['common'])),
      ...content,
    },
  }
}

export default function SizeChart({ value }: { value: string }) {
  const { t } = useTranslation(['common'])

  const breadcrumbs: Array<Breadcrumb> = [
    { path: '/', label: t('common:breadcrumbs.home') },
    { label: t('common:breadcrumbs.sizeChart') },
  ]

  return (
    <>
      <Head>
        <title>{t('common:metaTitles.sizeChart')}</title>
        <meta
          name="description"
          content={t('common:metaDescriptions.sizeChart')}
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={t(`common:metaTitles.sizeChart`)} />
        <meta
          property="og:image"
          content="https://ennsens.com/assets/meta/og-image.jpg"
        />
        <meta property="og:image:alt" content={t('common:slogan')} />
        <meta
          property="og:description"
          content={t('common:metaDescriptions.sizeChart')}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={t(`common:metaTitles.sizeChart`)} />
        <meta
          name="twitter:description"
          content={t('common:metaDescriptions.sizeChart')}
        />
        <meta
          name="twitter:image"
          content="https://ennsens.com/assets/meta/og-image.jpg"
        />
        <meta name="twitter:image:alt" content={t('common:slogan')} />
      </Head>
      <Hero
        title={t('common:breadcrumbs.sizeChart')}
        breadcrumbs={breadcrumbs}
      />
      <Container className="my-20">
        <div
          className="md-content"
          dangerouslySetInnerHTML={{ __html: value }}
        />
      </Container>
    </>
  )
}

SizeChart.Layout = Layout
